import { useRouter } from 'expo-router';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import Illustration from 'shared/components/vxl/Illustration/Illustration';
import ListItem from 'shared/components/vxl/ListItem/ListItem';
import BodyBaseText from 'shared/components/vxl/typography/primary/body/BodyBaseText';
import TitleMdText from 'shared/components/vxl/typography/primary/title/TitleMdText';
import { VXLComponentId } from 'shared/renderer/types';
import theme from 'shared/styles/theme';

interface NoDisputes {
  selectedTab: string;
}
const NoDisputesScreen = ({ selectedTab }: NoDisputes) => {
  const router = useRouter();
  const { t: translatedText } = useTranslation('myVaro', {
    keyPrefix: 'disputes',
  });
  return (
    <View style={styles.container} testID="noDisputes">
      <View style={styles.image}>
        <Illustration illustration="WALLET_B" />
      </View>
      <TitleMdText style={styles.text}>
        {translatedText(
          selectedTab === 'open' ? 'noOpenDisputes' : 'noClosedDisputes',
        )}
      </TitleMdText>
      {selectedTab === 'closed' ? (
        <BodyBaseText style={styles.text} numberOfLines={0}>
          {translatedText('noClosedDisputesSecondaryText')}
        </BodyBaseText>
      ) : null}
      {selectedTab === 'open' ? (
        <View style={styles.listItemContainer}>
          <ListItem
            primaryCopy={translatedText('emptyStateTitle')}
            secondaryCopy={translatedText('emptyStateSubtitle')}
            leadingAccessory={{
              id: 'MONEY_ICON',
              name: VXLComponentId.ICON,
              props: {
                variant: 'MD',
                iconKey: 'MONEY',
              },
            }}
            onPress={() => router.push('/myvaro/help/call-us')}
          />
        </View>
      ) : null}
    </View>
  );
};

const styles = StyleSheet.create({
  container: { alignItems: 'center' },
  image: {
    height: 126,
    paddingVertical: theme.spacing.m,
    width: 126,
  },
  listItemContainer: {
    width: '100%',
  },
  text: {
    paddingBottom: theme.spacing.s,
    paddingHorizontal: theme.spacing.m,
    textAlign: 'center',
  },
});

export default NoDisputesScreen;
